var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"mx-0 fa-star",class:{'text-success fa': _vm.in_compare, 'text-muted far': !_vm.in_compare},staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.in_compare ? 'Удалить из избранного' : 'Добавить в избраное'},on:{"click":function($event){return _vm.$emit('toggle-compare', _vm.bib)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }